import Ornament from "@/components/Ornament";

const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1727280376746-b89107a5b0df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHx0YW5kb29yaSUyMGNoaWNrZW4lMjBwbGF0dGVyfGVufDB8fHx8MTc5MTI2MTQzNHww&ixlib=rb-4.1.0&q=85",
    alt: "Smoking tandoor chicken platter with lime and mint chutney",
    label: "Clay Oven Tandoor",
    caption: "Fresh Tandoor & Kebabs",
  },
  {
    url: "https://images.unsplash.com/photo-1596797038530-2c107229654b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBtZWF0JTIwY3Vycnl8ZW58MHx8fHwxNzkxMjYxNDM0fDA&ixlib=rb-4.1.0&q=85",
    alt: "Authentic deep red Savji mutton curry served in copper bowl",
    label: "Regional Pride",
    caption: "Nagpur Savji Specialities",
  },
  {
    url: "https://images.unsplash.com/photo-1716550781939-beb7d7247aae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxtdXR0b24lMjBiaXJ5YW5pfGVufDB8fHx8MTc5MTI2MTQzNHww&ixlib=rb-4.1.0&q=85",
    alt: "Layered mutton dum biryani garnished with fried onions and mint",
    label: "Dum Pukht",
    caption: "Handi & Dum Biryanis",
  },
  {
    url: "https://images.unsplash.com/photo-1781332146569-9c5093bc2ca5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwYW5lZXIlMjB0aWtrYSUyMG5hYW58ZW58MHx8fHwxNzkxMjYxNDM0fDA&ixlib=rb-4.1.0&q=85",
    alt: "Sizzling hot paneer tikka and butter naan straight from the bhatti",
    label: "Vegetarian & Breads",
    caption: "Fresh Naans & Sizzlers",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-20 px-6 max-w-7xl mx-auto"
    >
      <div className="text-center max-w-2xl mx-auto mb-12" data-reveal>
        <span className="text-xs uppercase tracking-widest text-[#D4AF37] block mb-2">
          The Visual Feast
        </span>
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#F3EAD8]">
          Crafted for Nagpur Diners
        </h2>
        <p className="text-sm text-[#A8B8C0] mt-3">
          From glowing clay tandoors to slow-simmered handi pots, every platter
          is made fresh to order.
        </p>
        <Ornament />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {GALLERY.map((img, i) => (
          <div
            key={img.label}
            data-testid={`gallery-card-${i + 1}`}
            data-reveal
            style={{ transitionDelay: `${i * 0.12}s` }}
            className="group relative rounded-lg overflow-hidden border border-[#1E313D] aspect-[4/5] hover:border-[#D4AF37]/50 transition-colors"
          >
            <img
              src={img.url}
              alt={img.alt}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1319] via-transparent to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4">
              <span className="text-xs uppercase tracking-wider text-[#F7D774]">
                {img.label}
              </span>
              <p className="text-sm font-semibold text-[#F3EAD8]">
                {img.caption}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
